export const defaultToastConfig = {
  position: "bottom-right",
  autoClose: 7000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  theme: "light",
  limit: 2,
};